import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {UserGoalDetail} from "./user-goal-detail";

const UserGoalDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/usergoals');
    }

    return (
        <UserGoalDetail id={id} onClose={onClose}/>
    )

});

export default UserGoalDetailPage;